import producerCompliancePolicyAttachmentSaga from 'Agent/AgentDocumentation/sagas/producerCompliancePolicyAttachmentSaga';
import {all} from 'redux-saga/effects';

export default function*() {
  yield all([producerCompliancePolicyAttachmentSaga()]);
}
